import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HeaderContent from '@/components/layout/HeaderContent.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderContent),
    _createVNode(_component_router_view),
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      href: "https://lin.ee/8je37Jo",
      className: " fixed right-0 top-[30%] w-[3.5rem] z-[100]",
      target: "_blank"
    }, [
      _createElementVNode("img", {
        src: "https://static-jp.theckb.com/static-asset/sellerstation/line_icon.png",
        alt: ""
      })
    ], -1))
  ], 64))
}
}

})